export default "__VITE_ASSET__Dz34mf8o__"